// Importaciones y configuración base
import axios from 'axios';
import {
  API_BASE_MEDICAL_CONDITION_URL,  
} from "../../../../helpers/urlHelper";

// ========================================================================
// 🏥 CONFIGURACIÓN BASE - CORREGIDA
// ========================================================================

// Base URL del servidor - DEBE COINCIDIR CON EL SERVER
const API_BASE_URL = API_BASE_MEDICAL_CONDITION_URL; // Puerto y ruta base correctos

// URLs para condiciones médicas - CORREGIDAS
const API_MEDICAL_CONDITION_CREATE = `${API_BASE_URL}/medical-conditions`;
const API_MEDICAL_CONDITION_LIST = `${API_BASE_URL}/medical-conditions`;
const API_MEDICAL_CONDITION_DETAILS = `${API_BASE_URL}/medical-conditions`;
const API_MEDICAL_CONDITION_UPDATE = `${API_BASE_URL}/medical-conditions`;
const API_MEDICAL_CONDITION_DELETE = `${API_BASE_URL}/medical-conditions`;
const API_MEDICAL_CONDITION_BY_PATIENT = `${API_BASE_URL}/medical-conditions/patient`;

// ========================================================================
// 🏥 SERVICIO DE CONDICIONES MÉDICAS - CORREGIDO
// ========================================================================

class MedicalConditionService {
  
  /**
   * Crear una nueva condición médica - FUNCIÓN PRINCIPAL CORREGIDA
   * @param {Object} conditionData - Datos de la condición médica
   * @returns {Promise<Object>} Respuesta del servidor
   */
  async createCondition(conditionData) {
    try {
      console.log('🔄 Creating condition with URL:', API_MEDICAL_CONDITION_CREATE);
      console.log('🔄 Condition data:', conditionData);
      
      const response = await axios.post(API_MEDICAL_CONDITION_CREATE, conditionData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        timeout: 30000 // 30 segundos timeout
      });
      
      console.log('✅ Condition created successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating condition:', error);
      console.error('❌ Request URL:', API_MEDICAL_CONDITION_CREATE);
      console.error('❌ Request data:', conditionData);
      
      if (error.response) {
        console.error('❌ Response status:', error.response.status);
        console.error('❌ Response data:', error.response.data);
      } else if (error.request) {
        console.error('❌ No response received:', error.request);
      } else {
        console.error('❌ Request setup error:', error.message);
      }
      
      throw this.handleError(error);
    }
  }

  /**
   * Obtener condiciones médicas por paciente - CORREGIDA
   * @param {string} patientId - ID del paciente
   * @param {Object} params - Parámetros adicionales
   * @returns {Promise<Object>} Lista de condiciones del paciente
   */
  async getConditionsByPatient(patientId, params = {}) {
    try {
      let url = `${API_MEDICAL_CONDITION_BY_PATIENT}/${patientId}`;
      console.log('🔄 Getting conditions by patient with URL:', url);
      
      if (Object.keys(params).length > 0) {
        const queryParams = new URLSearchParams(params);
        url += `?${queryParams.toString()}`;
      }
      
      const response = await axios.get(url, {
        headers: {
          'Accept': 'application/json'
        },
        timeout: 30000
      });
      
      console.log('✅ Conditions retrieved successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error getting conditions by patient:', error);
      throw this.handleError(error);
    }
  }

  /**
   * Obtener todas las condiciones médicas - CORREGIDA
   * @param {Object} params - Parámetros de consulta
   * @returns {Promise<Object>} Lista de condiciones médicas
   */
  async getAllConditions(params = {}) {
    try {
      let url = API_MEDICAL_CONDITION_LIST;
      
      if (Object.keys(params).length > 0) {
        const queryParams = new URLSearchParams();
        Object.keys(params).forEach(key => {
          if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
            queryParams.append(key, params[key]);
          }
        });
        
        const queryString = queryParams.toString();
        if (queryString) {
          url += `?${queryString}`;
        }
      }
      
      console.log('🔄 Getting all conditions with URL:', url);
      
      const response = await axios.get(url, {
        headers: {
          'Accept': 'application/json'
        },
        timeout: 30000
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ Error getting all conditions:', error);
      throw this.handleError(error);
    }
  }

  /**
   * Obtener una condición médica por ID - CORREGIDA
   * @param {string} conditionId - ID de la condición médica
   * @returns {Promise<Object>} Datos de la condición médica
   */
  async getConditionById(conditionId) {
    try {
      const url = `${API_MEDICAL_CONDITION_DETAILS}/${conditionId}`;
      console.log('🔄 Getting condition by ID with URL:', url);
      
      const response = await axios.get(url, {
        headers: {
          'Accept': 'application/json'
        },
        timeout: 30000
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ Error getting condition by ID:', error);
      throw this.handleError(error);
    }
  }

  /**
   * Actualizar una condición médica - CORREGIDA
   * @param {string} conditionId - ID de la condición médica
   * @param {Object} updateData - Datos a actualizar
   * @returns {Promise<Object>} Condición médica actualizada
   */
  async updateCondition(conditionId, updateData) {
    try {
      const url = `${API_MEDICAL_CONDITION_UPDATE}/${conditionId}`;
      console.log('🔄 Updating condition with URL:', url);
      console.log('🔄 Update data:', updateData);
      
      const response = await axios.put(url, updateData, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        timeout: 30000
      });
      
      console.log('✅ Condition updated successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating condition:', error);
      throw this.handleError(error);
    }
  }

  /**
   * Eliminar una condición médica - CORREGIDA
   * @param {string} conditionId - ID de la condición médica
   * @returns {Promise<Object>} Confirmación de eliminación
   */
  async deleteCondition(conditionId) {
    try {
      const url = `${API_MEDICAL_CONDITION_DELETE}/${conditionId}`;
      console.log('🔄 Deleting condition with URL:', url);
      
      const response = await axios.delete(url, {
        headers: {
          'Accept': 'application/json'
        },
        timeout: 30000
      });
      
      return response.data;
    } catch (error) {
      console.error('❌ Error deleting condition:', error);
      throw this.handleError(error);
    }
  }

  // ========================================================================
  // ⚠️ MANEJO DE ERRORES - MEJORADO
  // ========================================================================

  /**
   * Manejo centralizado de errores
   * @param {Error} error - Error capturado
   * @returns {Object} Error formateado
   */
  handleError(error) {
    if (error.response) {
      // Error de respuesta del servidor
      const status = error.response.status;
      const data = error.response.data;
      
      let message = 'Error en el servidor';
      
      // Extraer mensaje específico del servidor
      if (typeof data === 'string') {
        // Si la respuesta es HTML (como el error 404), extraer mensaje útil
        if (data.includes('Cannot POST') || data.includes('Cannot GET')) {
          message = 'Endpoint no encontrado. Verifique la configuración del servidor.';
        } else {
          message = data;
        }
      } else if (data?.message) {
        message = data.message;
      } else if (data?.error) {
        message = data.error;
      }
      
      // Mensajes específicos por código de estado
      switch (status) {
        case 400:
          message = `Datos inválidos: ${message}`;
          break;
        case 401:
          message = 'No autorizado. Inicie sesión nuevamente.';
          break;
        case 403:
          message = 'Acceso denegado.';
          break;
        case 404:
          message = 'Recurso no encontrado. Verifique la configuración del servidor.';
          break;
        case 422:
          message = `Error de validación: ${message}`;
          break;
        case 500:
          message = 'Error interno del servidor.';
          break;
      }
      
      return {
        success: false,
        message,
        status,
        data: data
      };
    } else if (error.request) {
      // Error de red/conexión
      return {
        success: false,
        message: 'Error de conexión. Verifique su conexión a internet y que el servidor esté funcionando.',
        status: 0,
        data: null
      };
    } else {
      // Error en la configuración de la petición
      return {
        success: false,
        message: error.message || 'Error desconocido',
        status: 0,
        data: null
      };
    }
  }

  // ========================================================================
  // 🔧 MÉTODOS DE UTILIDAD
  // ========================================================================

  /**
   * Verificar conectividad con el servidor
   * @returns {Promise<boolean>} True si el servidor responde
   */
  async ping() {
    try {
      const response = await axios.get(`${API_BASE_URL}/health`, {
        timeout: 5000
      });
      return response.status === 200;
    } catch (error) {
      console.warn('⚠️ Server ping failed:', error.message);
      return false;
    }
  }

  /**
   * Obtener configuración actual del servicio
   * @returns {Object} Configuración del servicio
   */
  getConfig() {
    return {
      baseUrl: API_BASE_URL,
      endpoints: {
        create: API_MEDICAL_CONDITION_CREATE,
        list: API_MEDICAL_CONDITION_LIST,
        details: API_MEDICAL_CONDITION_DETAILS,
        update: API_MEDICAL_CONDITION_UPDATE,
        delete: API_MEDICAL_CONDITION_DELETE,
        byPatient: API_MEDICAL_CONDITION_BY_PATIENT
      }
    };
  }
}

// Exportar instancia singleton del servicio
export default new MedicalConditionService();